import {useEffect, useState} from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {COOKIESPREFIX } from '../../../config';
import { useCookies } from 'react-cookie';
import { Login } from '../../../actions/actions';
import { connect } from 'react-redux';
import TgatherLogoSvg from '../../../svgs/TgatherLogoSvg';

function Screen(props){
    const navigate = useNavigate();
    const location = useLocation();
    const [curScreen, setCurScreen] = useState('/')
    const [cookies, setCookie, removeCookie] = useCookies([`${COOKIESPREFIX}_cred`,`${COOKIESPREFIX}_token`]);
    useEffect(() => {
        const pathName = location.pathname.split('/')[1]
        setCurScreen(`/${pathName}`)
    },[location])
    const navigateTo=(str)=>()=>{
        navigate(str)
    }
    function logout(){
        removeCookie(`${COOKIESPREFIX}_cred`,{path:'/'});
        removeCookie(`${COOKIESPREFIX}_token`,{path:'/'});
        props.dispatch(Login(false))
        navigate('/tshop')
    }


    return (
        <div className='relative text-white bg-[#dddddd] flex justify-start items-stretch flex-row w-full text-[12px]' style={{height:105,maxHeight:105,minHeight:105,overflow:'hidden'}}>
            <div className='h-full relative text-white bg-[#dddddd] flex justify-between items-stretch flex-row w-full' style={{overflowX:'auto',gap:24}}>

                <div className='absolute bottom-0 w-full h-[105px] ' style={{background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)'}}/>

                <div className="flex items-center justify-center p-[24px]">
                    <TgatherLogoSvg width={160}/>
                </div>
                <div className='flex flex-row items-center justify-start gap-4 text-[#6E604C] px-[24px] z-[2]'>
                    <div className='text-[12px]'>管理員, {props.token?.username}</div>
                    <div className='text-[14px] font-bold cursor-pointer underline' onClick={logout}>登出</div>
                </div>
            </div>

        </div>
    )
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Screen)